import { ReferralLisState } from "@core/store/types/admin/lists/referralList";
import { GET_REFERRALS, SET_REFERRALS } from "@core/store/action-constants";
import { ActionTree, GetterTree, Module, MutationTree } from "vuex";
import { RootState } from "@core/store/root-state";
import i18n from "@core/plugins/i18n";
import { SET_EMPTY } from "@core/store/mutation-constants";

const initialState = (): ReferralLisState => {
  return {
    data: {}
  };
};

const state: () => ReferralLisState = initialState;

const getters: GetterTree<ReferralLisState, RootState> = {};

const mutations: MutationTree<ReferralLisState> = {
  [SET_REFERRALS] (state, partnerNetwork: ReferralLisState["data"]) {
    state.data = partnerNetwork;
  },
  
  [SET_EMPTY] (state) {
    Object.assign(state, initialState());
  }
};

const actions: ActionTree<ReferralLisState, RootState> = {
  [GET_REFERRALS] ({ commit }) {
    const items = [
      { label: i18n.t("admin.users.webmasters.filters.values.referral"), value: "isReferral" },
      { label: i18n.t("admin.users.webmasters.filters.values.referrer"), value: "isReferrer" }
    ];
    commit(SET_REFERRALS, {
      items,
      count: items.length
    });
  }
};

export const referralList: Module<ReferralLisState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
